<template>
    <div class="index">

        <!-- 主页 -->
        <div class="index-search">
            <div class="search-box">
                <p class="search-title">证书查询</p>
                <p class="search-number">身份证号码：</p>
                <input class="search-input" v-model="number" placeholder="请输入身份证号码">
                <div class="submit-button" @click="openCover">立即查询</div>
            </div>
        </div>

        <!-- 遮罩层弹窗 -->
        <div class="cover-box" v-if="coverShow == true">
            <div class="cover-box-item">
                <p class="search-title">查询结果</p>
                <div class="user-inf">
                    <p class="user-inf-item">姓名：{{ name }}</p>
                    <p class="user-inf-item">身份证号：{{ idNumber }}</p>
                    <div v-for="(item, index) in list" :key="index">
                        <div v-if="item.ifPass == 1">
                            <p class="user-inf-item" >您已完成<span v-show="item.rankType == 2">高级家庭教育指导师</span><span v-show="item.rankType == 1">家庭教育指导师</span><span v-show="item.rankType == 3">家园共育指导师</span><span v-show="item.rankType == 4">家庭教育指导员</span>课程学习，并通过考核，考核等级为{{ item.cardLevelName }}，经审核认定，具备相应的专业知识和职业技能，予以发证。</p>
                        </div>
                        <p v-else>很遗憾，您未通过<span v-show="item.rankType == 2">高级家庭教育指导师</span><span v-show="item.rankType == 1">家庭教育指导师</span><span v-show="item.rankType == 3">家园共育指导师</span><span v-show="item.rankType == 4">家庭教育指导员</span>考核。</p>
                    </div>
                    
                </div>
                <div class="close-button" @click="closeCover"></div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            return {
                number: '',
                coverShow: false,
                name: '',
                idNumber: '',
                list: []
                // level: '',
                // ifPass: '',

            }
        },
        methods: {
            openCover() {
                this.http.get('/certificate/search?idCard=' + this.number).then(res => {
                    if(res.data.rescode == 200) {
                        this.coverShow = true
                        this.name = res.data.data[0].userName
                        this.idNumber = res.data.data[0].idCard
                        this.list = res.data.data
                        // this.level = res.data.data.cardLevelName
                        // this.ifPass = res.data.data.ifPass

                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.msg,
                            type: 'error'
                        })
                    }
                }) 
            },
            closeCover() {
                this.coverShow = false
            }
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .index-search {
            width: 100%;
            height: 670px;
            background-image: url('../../assets/index/bg.png');
            background-size: 100% 100%;
            position: relative;
            .search-box {
                width: 600px;
                height: 374px;
                background: #F4F3F3;
                border-radius: 26px;
                position: absolute;
                right: 398px;
                top: 148px;
                padding: 30px;
                box-sizing: border-box;
                .search-title {
                    text-align: center;
                    font-size: 36px;
                    font-weight: 500;
                    color: #333333;
                }
                .search-number {
                    font-size: 30px;
                    font-weight: 400;
                    color: #333333;
                    margin-top: 20px;
                }
                .search-input {
                    width: 100%;
                    height: 69px;
                    background: #FFFFFF;
                    border-radius: 15px;
                    margin-top: 15px;
                    border: 0.5px solid #e1e0e0;
                    font-size: 20px;
                    padding: 17px 20px;
                    box-sizing: border-box;
                    outline: none;
                }
                .submit-button {
                    width: 265px;
                    height: 80px;
                    background: #0091FF;
                    border-radius: 8px;
                    font-size: 30px;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 80px;
                    text-align: center;
                    margin: 0 auto;
                    margin-top: 34px;
                    cursor: pointer;
                }
            }
        }

        .cover-box {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.45);
            z-index: 999;
            .cover-box-item {
                width: 900px;
                // height: 450px;
                background: #FFFFFF;
                border-radius: 15px;
                margin: 0 auto;
                margin-top: 150px;
                padding: 40px 60px;
                box-sizing: border-box;
                position: relative;
                .search-title {
                    text-align: center;
                    font-size: 36px;
                    font-weight: 500;
                    color: #333333;
                }
                .user-inf {
                    margin-top: 60px;
                    .user-inf-item {
                        font-size: 30px;
                        font-weight: 500;
                        color: #333333;
                        line-height: 42px;
                        margin-bottom: 20px;
                    }
                }
                .close-button {
                    position: absolute;
                    width: 68px;
                    height: 68px;
                    background-image: url('../../assets/index/close.png');
                    background-size: 100% 100%;
                    top: -86px;
                    right: -86px;
                    cursor: pointer;
                }
            }
            
            
        } 
    }
</style>